import { lazy } from 'react';
import { chunkErrorUtils } from '../publicPath';

const { isChunkError, doChunkReload, CHUNK_RELOAD_KEY } = chunkErrorUtils;

/**
 * Like React.lazy, but triggers a one-time reload when a split chunk is missing (stale embed tab).
 */
export function lazyWithRetry(factory) {
  return lazy(async () => {
    try {
      const mod = await factory();
      if (typeof sessionStorage !== 'undefined') {
        try {
          sessionStorage.removeItem(CHUNK_RELOAD_KEY);
        } catch (e) {
          /* ignore */
        }
      }
      return mod;
    } catch (error) {
      if (isChunkError(error)) {
        doChunkReload();
        return new Promise(() => {});
      }
      throw error;
    }
  });
}
